import {
  Anchor,
  Button,
  Icon,
  LockHollowSVG,
  PrintSVG,
} from "@newsela/angelou";

import { withTrackEvent, objectTypes, actionNames } from "@newsela/snitch";
import { EventProperties } from "@/types/models/EventProperties.interface";
import getPrintButtonEventProperties from "@/view/PrintSelector/utils/getPrintButtonEventProperties";
import { PRINT_OPTIONS } from "../PrintSelector/getPrintOptions";
import {
  iconCss,
  lockIconCss,
  printIconCss,
  rootCss,
} from "./PrintButton.style";

interface PrintButtonInterface {
  contentId: string;
  currentLevelId: string;
  currentLevelHeaderId: string;
  isArticlePrintDisabled: boolean;
  showIconOnly?: boolean | undefined;
}

const AnchorWithTrackEvent = withTrackEvent(Anchor);

const PrintButton = ({
  contentId,
  currentLevelId,
  currentLevelHeaderId,
  isArticlePrintDisabled = false,
  showIconOnly = false,
}: PrintButtonInterface) => {
  const baseUrl = `/content/${currentLevelId}/print/?format=pdf&content=`;

  const eventProperties: EventProperties = {
    objectType: objectTypes.content,
    actionName: actionNames.print,
    streamProperties: {
      content_type: "Article",
      description: "Open print options",
      content_id: currentLevelId,
      article_header_content_id: currentLevelHeaderId,
      article_story_content_id: contentId,
    },
  };

  const singlePrintOption: { queryParam: string; label: string } =
    PRINT_OPTIONS.ARTICLE_ONLY;
  const { queryParam } = singlePrintOption;
  const printOptionEventProperties = getPrintButtonEventProperties(
    singlePrintOption,
    eventProperties,
  );

  const href = `${baseUrl}${queryParam}`;

  const disabledProps = {
    ariaProps: {
      "aria-disabled": true,
      role: "link",
    },
  };

  return (
    <>
      <AnchorWithTrackEvent
        __cssFor={{
          /* @ts-expect-error Property 'children' does not exist on type */
          root: rootCss(isArticlePrintDisabled, showIconOnly),
          Icon: {
            root: iconCss,
          },
        }}
        dataProps={{ "data-qa-selector": `print-link-${queryParam}` }}
        disabled={isArticlePrintDisabled}
        {...(isArticlePrintDisabled ? disabledProps : { href })}
        openInNewTab
        styleAnchorAsButton={{
          flavor: Button.flavors.muted,
        }}
        {...printOptionEventProperties}
      >
        {showIconOnly ? (
          <Icon
            __cssFor={{ root: printIconCss }}
            isDecorative={false}
            title="print"
            size={Button.sizes.md}
            SvgComponent={PrintSVG}
          />
        ) : isArticlePrintDisabled ? (
          <>
            <Icon
              isDecorative={false}
              title="locked"
              __cssFor={{ root: lockIconCss(isArticlePrintDisabled, true) }}
              size={Button.sizes.md}
              SvgComponent={LockHollowSVG}
            />
            Print
          </>
        ) : (
          "Print"
        )}
      </AnchorWithTrackEvent>
    </>
  );
};

export default PrintButton;
